<template>
  <div class="flex items-center">
    <span
      v-if="!currentRoute.includes(route.path) && !disableGoToBack"
      @click="goBackOrGivenPath"
      class="icon-arrow-left text-lg font-semibold mr-4 transition-300 hover:-translate-x-1 cursor-pointer"
    />
    <div
      v-for="(route, index) in routes"
      :key="index"
      class="flex items-center shrink-0"
      :class="[checkLastRoute(index), `text-[${textColor}]`]"
    >
      <LocalizedLink
        v-if="route.link"
        class="transition duration-500 text-2xl text-dark font-interDisplay font-semibold"
        :to="route.route"
      >
        {{ route.name }}
      </LocalizedLink>
      <p v-else-if="route.disabled" class="text-2xs">{{ route?.name }}</p>
      <LocalizedLink
        v-else
        class="transition duration-500 text-2xl text-dark font-interDisplay font-semibold"
        :to="route.route"
      >
        {{ route.name }}
      </LocalizedLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import LocalizedLink from "@/components/CLocalizedLink.vue";

interface IRoute {
  name: string;
  route: string;
  target?: boolean;
  link?: boolean;
  disabled?: boolean;
}

export interface Props {
  routes: IRoute[];
  hoverColor?: string;
  textColor?: string;
  disableGoToBack?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  hoverColor: "#52618F",
  textColor: "#191F2E",
  disableGoToBack: false,
});

const router = useRouter();
const route = useRoute();
const currentRoute = ["/", "/bots", "exchanges", "wallet", "guide"];
function goBackOrGivenPath() {
  router.go(-1);
}

const checkLastRoute = (index: number) => {
  if (index === props.routes.length - 1) {
    return "font-medium !text-gray cursor-not-allowed pointer-events-none";
  } else {
    return "font-medium text-dark hover:text-green cursor-pointer";
  }
};
</script>
